// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__Y76pH","title":"ClientInsurance_title__1rJ5I","itemText":"ClientInsurance_itemText__1niy8"};